export type CadenceType = 'daily' | 'weekly';

export const DAYS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 0, label: 'Sunday' },
];

export const HOURS = Array.from({ length: 24 }, (_, i) => {
  if (i === 0) return { value: 0, label: '12:00 AM' };
  if (i < 12) return { value: i, label: `${i}:00 AM` };
  if (i === 12) return { value: 12, label: '12:00 PM' };
  return { value: i, label: `${i - 12}:00 PM` };
});

export const buildCron = (
  cadenceType: CadenceType,
  hour: number,
  day?: number,
): string => {
  if (cadenceType === 'daily') {
    return `0 ${hour} * * *`;
  }
  return `0 ${hour} * * ${day ?? 1}`;
};

export const parseCron = (
  cron: string,
): { cadenceType: CadenceType; hour: number; day?: number } => {
  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) {
    return { cadenceType: 'daily', hour: 0 };
  }

  const hour = parseInt(parts[1], 10);
  if (!Number.isFinite(hour)) {
    return { cadenceType: 'daily', hour: 0 };
  }

  const dayOfWeek = parts[4];
  if (dayOfWeek === '*') {
    return { cadenceType: 'daily', hour };
  }

  const day = parseInt(dayOfWeek, 10);
  if (!Number.isFinite(day)) {
    return { cadenceType: 'daily', hour };
  }

  return { cadenceType: 'weekly', hour, day: day === 7 ? 0 : day };
};

export const describeCron = (cron: string): string => {
  const { cadenceType, hour, day } = parseCron(cron);
  const hourLabel = HOURS.find((h) => h.value === hour)?.label ?? `${hour}:00`;

  if (cadenceType === 'daily') {
    return `Daily at ${hourLabel}`;
  }
  const dayLabel = DAYS.find((d) => d.value === day)?.label ?? `Day ${day}`;
  return `Weekly on ${dayLabel} at ${hourLabel}`;
};
